module.exports = __webpack_public_path__ + "img/backgroundColor.9c8913ca.png";